/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable sonarjs/cognitive-complexity */

'use strict';

var formHelpers = require('./formErrors');
var utils = require('../utils');
var clientSideValidation = require('../components/clientSideValidation');
var loqateAddress = require('./loqateAddress');

/**
 * Populate the Billing Address Summary View
 * @param {string} parentSelector - the top level DOM selector for a unique address summary
 * @param {Object} address - the address data
 */
function populateAddressSummary(parentSelector, address) {
    var usePunctuation = $('#checkout-main').data('use-punctuation');
    var useSpaces = $('#checkout-main').data('use-spaces');
    $.each(address, function (attr) {
        var val = address[attr];
        if (usePunctuation && useSpaces && val && (attr === 'address1' || attr === 'address2' || attr === 'address3' || attr === 'city')) {
            val += ',&nbsp;';
        } else if (useSpaces && val && attr === 'stateCode') {
            val += '&nbsp;';
        }
        $('.' + attr, parentSelector).html(val || '');
    });
}

/**
 * returns a formed <option /> element
 * @param {Object} shipping - the shipping object (shipment model)
 * @param {boolean} selected - current shipping is selected (for PLI)
 * @param {order} order - the Order model
 * @param {Object} [options] - options
 * @returns {Object} - the jQuery / DOMElement
 */
function optionValueForAddress(shipping, selected, order, options) {
    var safeOptions = options || {};
    var isBilling = safeOptions.type && safeOptions.type === 'billing';
    var className = safeOptions.className || '';
    var isSelected = selected;
    var isNew = !shipping;
    if (typeof shipping === 'string') {
        return $(
            '<option class="'
            + className
            + '" disabled>'
            + shipping
            + '</option>'
        );
    }
    var safeShipping = shipping || {};
    var shippingAddress = safeShipping.shippingAddress || {};

    if (isBilling && isNew && !order.billing.matchingAddressId) {
        shippingAddress = order.billing.billingAddress.address || {};
        isNew = false;
        isSelected = true;
        safeShipping.UUID = 'manual-entry';
    }

    var uuid = safeShipping.UUID ? safeShipping.UUID : 'new';
    var optionEl = $('<option class="' + className + '" />');
    optionEl.val(uuid);

    var title;

    if (isNew) {
        title = order.resources.addNewAddress;
    } else {
        title = [];
        if (shippingAddress.firstName) {
            title.push(shippingAddress.firstName);
        }
        if (shippingAddress.lastName) {
            title.push(shippingAddress.lastName);
        }
        if (shippingAddress.address1) {
            title.push(shippingAddress.address1);
        }
        if (shippingAddress.address2) {
            title.push(shippingAddress.address2);
        }

        if (shippingAddress.address3) {
            title.push(shippingAddress.address3);
        }

        if (shippingAddress.city) {
            if (shippingAddress.state) {
                title.push(shippingAddress.city + ',');
            } else {
                title.push(shippingAddress.city);
            }
        }
        if (shippingAddress.stateCode) {
            title.push(shippingAddress.stateCode);
        }
        if (shippingAddress.postalCode) {
            title.push(shippingAddress.postalCode);
        }
        if (!isBilling && safeShipping.selectedShippingMethod) {
            title.push('-');
            title.push(safeShipping.selectedShippingMethod.displayName);
        }

        if (title.length > 2) {
            title = title.join(' ');
        } else {
            title = order.resources.newAddress;
        }
    }
    optionEl.text(title);

    var keyMap = {
        'data-first-name': 'firstName',
        'data-last-name': 'lastName',
        'data-first-name-phonetic': 'firstNamePhonetic',
        'data-last-name-phonetic': 'lastNamePhonetic',
        'data-address1': 'address1',
        'data-address2': 'address2',
        'data-address3': 'address3',
        'data-city': 'city',
        'data-state-code': 'stateCode',
        'data-postal-code': 'postalCode',
        'data-country-code': 'countryCode',
        'data-phone': 'phone',
        'data-phone-code': 'phoneCode'
    };
    $.each(keyMap, function (key) {
        var mappedKey = keyMap[key];
        var mappedValue = shippingAddress[mappedKey];
        // In case of country code
        if (mappedValue && typeof mappedValue === 'object') {
            mappedValue = mappedValue.value;
        }

        optionEl.attr(key, mappedValue || '');
    });

    var giftObj = {
        'data-is-gift': 'isGift',
        'data-gift-message': 'giftMessage'
    };

    $.each(giftObj, function (key) {
        var mappedKey = giftObj[key];
        var mappedValue = safeShipping[mappedKey];
        optionEl.attr(key, mappedValue || '');
    });

    if (isSelected) {
        optionEl.attr('selected', true);
    }

    return optionEl;
}

/**
 * returns address properties from a UI form
 * @param {Form} form - the Form element
 * @returns {Object} - a JSON object with all values
 */
function getAddressFieldsFromUI(form) {
    var addressObj = {
        firstName: $('input[name$=_firstName]', form).val(),
        lastName: $('input[name$=_lastName]', form).val(),
        firstNamePhonetic: $('input[name$=_firstNamePhonetic]', form).val(),
        lastNamePhonetic: $('input[name$=_lastNamePhonetic]', form).val(),
        address1: $('input[name$=_address1]', form).val(),
        address2: $('input[name$=_address2]', form).val(),
        address3: $('input[name$=_address3]', form).val(),
        city: $('select[name$=_city],input[name$=_city]',
            form).val(),
        postalCode: $('input[name$=_postalCode]', form).val(),
        stateCode: $(
            'select[name$=_stateCode],input[name$=_stateCode]',
            form
        ).val(),
        countryCode: $('select[name$=_country]', form).val() || $('select[name$=_country]', form).attr('value'),
        phone: $('input[name$=_phone]', form).val(),
        phoneCode: $('select[name$=_phoneCode]', form).val()
    };

    // Data for 3 dropdown fields (state/city/postalCode) will not be populated in shipping form if the dropdown options are removed due to any business requirement.
    // Please refer to PP-1811 where we have removed City / Postal Code for few localities for TW locale, so now we have to map those values from selected option -> #shipmentSelector-default. This is a dropdown that's responsible to populate shipping form based on selected saved address. We will only map the data to fields that are missing data from form elements. Guest Users are not impacted from this change.
    var $selectedAddressDropdown = form.find('.js-shipping-address-dropdown');
    var optionsData = $selectedAddressDropdown.length > 0 ? $selectedAddressDropdown.find('option:selected').data() : null;
    if (optionsData && Object.keys(optionsData).length) {
        addressObj.stateCode = !addressObj.stateCode ? optionsData.stateCode : addressObj.stateCode;
        addressObj.city = !addressObj.city ? optionsData.city : addressObj.city;
        addressObj.postalCode = !addressObj.postalCode ? optionsData.postalCode : addressObj.postalCode;
    }
    return addressObj;
}

module.exports = {
    methods: {
        populateAddressSummary: populateAddressSummary,
        optionValueForAddress: optionValueForAddress,
        getAddressFieldsFromUI: getAddressFieldsFromUI
    },

    showDetails: function () {
        $('.btn-show-details').on('click', function () {
            var form = $(this).closest('form');
            formHelpers.clearPreviousErrors('.shipping-form');
            var selectedCountry = $('#shippingCountry').find('option[selected]').val();
            if (!$('.js-save-shipaddress-block').hasClass('d-none')) {
                $('.js-save-shipaddress-block').addClass('d-none');
            }
            if ($('.billing-address').hasClass('d-none')) {
                $('.billing-address').removeClass('d-none');
            }
            if ($('.js-updateadd-header').hasClass('d-none')) {
                $('.js-updateadd-header').removeClass('d-none');
            }
            if (!$('.js-updateadd-header-add').hasClass('d-none')) {
                $('.js-updateadd-header-add').addClass('d-none');
            }
            form.find('.shipping-address-block').removeClass('d-none');
            if (!$('.save-address-nb').hasClass('d-none')) {
                $('.save-address-nb').addClass('d-none');
            }
            var addrButton = form.find('.js-update-edited-shipaddress');
            addrButton.text(addrButton.data('update-text'));

            if (
                !$('.billing-address-block .save-address-nb').hasClass('d-none')
            ) {
                $('.billing-address-block .save-address-nb').addClass('d-none');
            }

            if (selectedCountry) {
                $('#shippingCountry').val(selectedCountry);
            }

            form.attr('data-address-mode', 'details');
            form.find('.multi-ship-address-actions').removeClass('d-none');
            form.find(
                '.multi-ship-action-buttons .col-12.btn-save-multi-ship'
            ).addClass('d-none');
        });
    },
    updateEditedDetails: function () {
        // $('.shipping-address-block').addClass('d-none');
        $('.js-update-edited-shipaddress').on('click', function (e) {
            var $this = $(this);
            var form = $this.closest('form');
            var addressEditMode = document.querySelector('.shipping-form').dataset.addressMode;
            if (addressEditMode === 'details') {
                form.find('#saveShippingAddr').prop('checked', true);
            }
            if (clientSideValidation.functions.validateClientForm(form[0], e)) {
                import('../zipCodes').then(function (zipCodes) {
                    var $shippingAddressBlock = $('.shipping-address-block');
                    clientSideValidation.functions.clearForm(form);
                    var postalCode = $('.shippingZipCode').val();
                    var country = $('.shippingCountry').val();
                    var zipCodeSelector = '.shipping-address-block .shippingZipCode';
                    var isZipCodeValid = true;
                    if (country && postalCode) {
                        isZipCodeValid = utils.isZipCodeValid(postalCode, country, zipCodeSelector, zipCodes.zipCodeJSON);
                    }

                    if (!isZipCodeValid) {
                        return;
                    }

                    var continueToSubmit = true;
                    var addressVerifyUrl = $('#addressVerifyUrl').val();
                    var addressNeedsVerification = $('#shippingAddressOneLoqate').attr('data-address-needs-verification') === 'true';
                    if (addressNeedsVerification && addressVerifyUrl) {
                        continueToSubmit = loqateAddress.submitAddressValidation(addressVerifyUrl, form.serialize(), false);
                    }

                    if (continueToSubmit) {
                        // perform AJAX to update selected address in customer profile
                        var shippingFormData = form.serialize();
                        var addrID = form.find('.addressSelector').val();
                        $shippingAddressBlock.spinner().start();
                        var updateUrl = $this.data('update-url');
                        updateUrl = updateUrl + '?addressId=' + addrID;
                        $.ajax({
                            url: updateUrl,
                            type: 'post',
                            data: shippingFormData
                        })
                            .done(function (response) {
                                var formSelector = '.single-shipping form';
                                // highlight fields with errors
                                if (response.error) {
                                    var data = response;
                                    if (data.fieldErrors.length) {
                                        $shippingAddressBlock.removeClass('d-none');
                                        data.fieldErrors.forEach(function (error) {
                                            if (Object.keys(error).length) {
                                                formHelpers.loadFormErrors(
                                                    formSelector,
                                                    error
                                                );
                                            }
                                        });
                                    }
                                } else {
                                    formHelpers.clearPreviousErrors('.shipping-form');
                                    form.find('.addressSelector').html(response).trigger('change');
                                    if (addressEditMode === 'details') {
                                        form.find('#saveShippingAddr').prop('checked', false);
                                    }
                                    $('.js-save-shipaddress-block').addClass('d-none');
                                    $('.js-updateadd-header').addClass('d-none');
                                    $('.shipment-selector-block').removeClass('d-none');
                                }
                                $shippingAddressBlock.spinner().stop();
                                if ($('.shipping-address').find('.alert').is(':visible')) {
                                    $('.shipping-address').find('.alert').addClass('d-none');
                                }
                            })
                            .fail(function () {
                                $shippingAddressBlock.spinner().stop();
                            });

                        $(document).trigger('save:updateShippingAddress');
                    }
                });
            } else {
                clientSideValidation.functions.scrollToErrorInPage($this);
            }
        });
    },
    cancelEditedDetails: function () {
        $('.js-cancel-update').on('click', function () {
            var $el = $(this);
            var $newEl;
            formHelpers.clearPreviousErrors('.shipping-form');
            var $saveShippingAddressBlock = $('.js-save-shipaddress-block');
            var $updatedHeader = $('.js-updateadd-header');
            var $addressBlock = $(this).parents('form').find('.shipping-address-block');
            if ($addressBlock.length > 0 && !($addressBlock.hasClass('d-none'))) {
                $addressBlock.addClass('d-none');
            }
            if ($saveShippingAddressBlock.length && !$saveShippingAddressBlock.hasClass('d-none')) {
                $saveShippingAddressBlock.addClass('d-none');
            }
            if (
                $el
                    .parents('form')
                    .find('.addressSelector')
                    .val() === 'new'
            ) {
                $newEl = $el
                    .parents('form')
                    .find('.addressSelector option')
                    .eq(2);
                $newEl.parent().val($newEl.val());
                $newEl.parent().trigger('change');
            } else {
                $newEl = $el
                    .parents('form')
                    .find('.addressSelector option[selected]');
                $newEl.parent().trigger('change');
            }
            if ($updatedHeader.length && !$updatedHeader.hasClass('d-none')) {
                $updatedHeader.addClass('d-none');
            }

            $(document).trigger('cancel:updateShippingAddress');
        });
    },

    addNewAddress: function () {
        $('.btn-add-new').on('click', function (e) {
            e.preventDefault();
            var $el = $(this);
            // Handle shipping address case
            var addrButton = $el
                .parents('form')
                .find('.js-update-edited-shipaddress');
            addrButton.text(addrButton.data('save-text'));
            if ($('.js-save-shipaddress-block').hasClass('d-none')) {
                $('.js-save-shipaddress-block').removeClass('d-none');
            }
            if (!$('.js-updateadd-header').hasClass('d-none')) {
                $('.js-updateadd-header').addClass('d-none');
            }
            if ($('.js-updateadd-header-add').hasClass('d-none')) {
                $('.js-updateadd-header-add').removeClass('d-none');
            }
            if ($('.save-address-nb').hasClass('d-none')) {
                $('.save-address-nb').removeClass('d-none');
            }

            var $addressSelector = $el
                .parents('form')
                .find('.addressSelector');
            var $oldEl = $addressSelector
                .find('option[selected]');
            $oldEl.removeAttr('selected');
            var $newEl = $addressSelector
                .find('option[value=new]');
            $newEl.attr('selected', 'selected');
            $addressSelector.trigger('change');

            var selectedCountryVal = $('#shippingCountry').find('option[selected]').val();
            if (selectedCountryVal) {
                $('#shippingCountry').val(selectedCountryVal);
            }
        });
    },

    billingAddrSameAsShippingAddr: function () {
        $('#shippingAddressUseAsBillingAddress').on('change', function () {
            if (!$('#shippingAddressUseAsBillingAddress').is(':checked')) {
                var $el = $(this);
                if ($el.parents('#dwfrm_billing').length > 0) {
                    $('body').trigger('checkout:clearBillingForm');
                    var selectCountryByDefault = $('.site-locale').val();
                    if (selectCountryByDefault) {
                        selectCountryByDefault = selectCountryByDefault.split('_');
                        var currentSelectionCountry = selectCountryByDefault.length > 1 ? selectCountryByDefault[1] : selectCountryByDefault[0];
                        $('#billingCountry').val(currentSelectionCountry.toUpperCase()).trigger('change');
                    }
                    formHelpers.clearPreviousErrors('.billing-information');
                    var $option = $(
                        $el.parents('form').find('.addressSelector option')[0]
                    );
                    $option.attr('value', 'new');
                    $el.parents('[data-address-mode]').attr(
                        'data-address-mode',
                        'new'
                    );
                    if ($('.billing-address').hasClass('d-none')) {
                        $('.billing-address').removeClass('d-none');
                    }
                    $('.js-billingAddressSelector').addClass('d-none');
                }
            } else {
                $('.billing-address').addClass('d-none').removeClass('d-block');
                $('#billingAddressSelector option:selected').removeAttr('selected');
                $('#billingAddressSelector option:nth-child(3)').attr('selected', 'selected');
                $('.js-billingAddressSelector').removeClass('d-none');
                $('#billingAddressSelector').trigger('change');
            }
        });
    }
};
